import React, { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';
import {
  getDateTimeFormat,
  getDisclosureActivitySummary,
  sortDisclosureActivityByNewest,
} from '../../DisclosureDelivery.utils';

import { entryStyles, listStyles, metaRowStyles } from './DisclosureAuditTrailDialog.styles';

const DisclosureAuditTrailDialog = ({ directory = {}, entries = [] }) => {
  const sortedEntries = useMemo(() => sortDisclosureActivityByNewest(entries), [entries]);

  if (!sortedEntries.length) {
    return (
      <Typography color="text.secondary" variant="regular14">
        No disclosure activity has been recorded yet.
      </Typography>
    );
  }

  return (
    <Box data-testid={DisclosureDeliveryTestIds.AUDIT_TRAIL_DIALOG} sx={listStyles}>
      {sortedEntries.map(entry => {
        const actorName = directory?.[entry.userId]?.name || 'Unknown user';

        return (
          <Box key={entry.id} sx={entryStyles}>
            <Typography variant="medium14">{getDisclosureActivitySummary(entry)}</Typography>
            <Box sx={metaRowStyles}>
              <Typography color="text.secondary" variant="regular12">
                {actorName}
              </Typography>
              <Typography color="text.secondary" variant="regular12">
                ·
              </Typography>
              <Typography color="text.secondary" variant="regular12">
                {getDateTimeFormat(entry.createdAt)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

DisclosureAuditTrailDialog.propTypes = {
  directory: PropTypes.objectOf(PropTypes.shape({ name: PropTypes.string })),
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      userId: PropTypes.string,
      eventType: PropTypes.string,
      description: PropTypes.string,
      createdAt: PropTypes.string,
    }),
  ),
};

export default DisclosureAuditTrailDialog;
